<template>
  <div>
    <button
      v-b-modal="`modal-teste-survey-${isTemplateEmailCustom}`"
      :title="`${$t('newAction.stepOne.titleTestLayoutEmail')}`"
      class="btn btn-primary"
    >
      <font-awesome-icon
        :icon="['fas', 'paper-plane']"
        style="font-size: 16px; margin-left: -2px;"
      />
    </button>
    <b-modal
      :id="`modal-teste-survey-${isTemplateEmailCustom}`"
      :title="`${$t('newAction.stepOne.titleTestLayoutEmail')}`"
    >
      <p>
        {{ $t('newAction.stepOne.modalTestSurvey') }}
      </p>
      <div class="add-email-test">
        <label>{{ $t('newAction.stepOne.addEmail') }}:</label>
        <input class="form-control" v-model="email" />
      </div>
      <template slot="modal-footer">
        <button @click="sendTestSurvey()" class="btn btn-primary">
          {{ $t('newAction.stepOne.sendTestEmail') }}
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import swal from 'sweetalert';
import validator from 'validator';
import api from '../../../services/api';

export default {
  data: () => ({
    userAuth: null,
    email: null,
  }),

  props: {
    isTemplateEmailCustom: {
    type: Boolean,
    required: false,
    default: false,
   }
  },

  computed: {
    ...mapState('actions', ['action']),
  },

  methods: {
    async sendTestSurvey() {
      try {
        if (validator.isEmail(this.email) === true) {
          await api.post(
            `/action/testSurvey`,
            {
              action: this.action,
              email: this.email,
              isTemplateCustom: this.isTemplateEmailCustom
            },
            {
              headers: { 'x-access-token': this.userAuth.token },
            },

            swal({
              title: this.$t('newAction.stepOne.testEmail.title'),
              text: this.$t('newAction.stepOne.testEmail.description'),
              icon: 'success',
            }),
          );
        } else {
          swal({
            title: this.$t('newAction.stepOne.invalidEmail.title'),
            text: this.$t('newAction.stepOne.invalidEmail.description'),
            icon: 'error',
          });
        }
      } catch (error) {
        swal({
          title: this.$t('newAction.stepOne.failedSendEmail.title'),
          text: this.$t('newAction.stepOne.failedSendEmail.description'),
          icon: 'error',
        });
      }
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },
};
</script>
<style>
.add-email-test {
  font-weight: 500;
  margin-top: 30px;
  margin-bottom: 10px;
}

.modal-footer {
  border-top: none;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/modal-test-survey-email/index.vue